import classNames from 'classnames'

import { Button } from '@/shared'

import style from './Actions.module.scss'

interface IProps {
    onHandleRefundRecord: () => void
}

export const Actions = (props: IProps) => {
    const { onHandleRefundRecord } = props
    return (
        <div className={style.container}>
            <Button onClick={onHandleRefundRecord} className={classNames(style.btn, style.cancel)}>
                Отменить запись
            </Button>
        </div>
    )
}
